import { getConfigValue } from '@/helpers/configHelper';

import axios from 'axios';

const authUrl = getConfigValue('authUrl');

export const sportsAuthorityService = {
  authenticateUser: (email, password) => {
    return axios.post(`${authUrl}/auth`, undefined, {
      headers: {
        Authorization: `Basic ${btoa(`${email}:${password}`)}`,
        'Content-Type': 'application/json'
      }
    });
  },

  fetchSession: async (sessionToken) => {
    return await axios.get(`${authUrl}/session`, {
      headers: {
        'X-SESSION-TOKEN': sessionToken
      }
    });
  },

  fetchMfaDevices: (sessionToken) => {
    return axios.get(`${authUrl}/mfa/devices`, {
      headers: {
        'X-SESSION-TOKEN': sessionToken
      }
    });
  },

  authorizeMfa: (authorizedUser) => {
    return axios.post(`${authUrl}/mfa/authorize`, { authorizedUser });
  },

  addMfaDevice: (device, authorizedUser) => {
    return axios.post(`${authUrl}/mfa/device`, {
      device,
      authorizedUser
    });
  },

  removeMfaDevice: (userId, deviceId) => {
    return axios.delete(`${authUrl}/mfa/users/${userId}/devices/${deviceId}`);
  },

  verifyOtpCode: (otp, flowId, accountId) => {
    return axios.post(`${authUrl}/mfa/verify`, { otp, flowId, accountId });
  },

  checkMfaVerifyStatus: (sessionToken) => {
    return axios.get(`${authUrl}/mfa/verify-status`, {
      headers: {
        'X-SESSION-TOKEN': sessionToken
      }
    });
  },

  resetMfaQuota: (email) => {
    return axios.post(`${authUrl}/mfa/reset-quota`, { email });
  },

  fetchFlowStatus: (flowId) => {
    return axios.get(`${authUrl}/mfa/flow/${flowId}`);
  },

  resetPassword: (token, newPassword) => {
    return axios.put(`${authUrl}/reset-password/${token}`, {
      Plaintext: newPassword
    });
  },

  forgotPassword: (email) => {
    return axios.put(`${authUrl}/forgot-password`, {
      email
    });
  }
};

export default sportsAuthorityService;
